module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item shadow",
    class: {
      'item-transferable': this.transferTarget && _vm.item.canTransferTo(this.transferTarget.characterId), duplicate: _vm.item.isDuplicate
    },
    style: ({
      'background': this.background
    }),
    attrs: {
      "title": _vm.item.definition.displayProperties.description
    },
    on: {
      "dblclick": function($event) {
        $event.stopPropagation();
        _vm.debugItem($event)
      },
      "click": function($event) {
        $event.stopPropagation();
        _vm.transferItem($event)
      }
    }
  }, [(_vm.tagsSelectorVisible) ? _c('tags-selector', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "close": function($event) {
        _vm.tagsSelectorVisible = false
      }
    }
  }, [_c('h2', {
    slot: "header"
  }, [_vm._v("foo bar")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "item-image",
    attrs: {
      "src": _vm.item.icon
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.item.data.itemInstanceId ? _vm.$router.push({
          name: 'item',
          params: {
            instanceId: _vm.item.data.itemInstanceId
          }
        }) : false
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.data.quantity > 1),
      expression: "item.data.quantity>1"
    }],
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.item.data.quantity))])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n      " + _vm._s(_vm.item.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "type-name"
  }, [_vm._v("\n      " + _vm._s(_vm.item.definition.itemTypeDisplayName) + ", " + _vm._s(_vm.item.bucket.displayProperties.name) + "\n    ")])]), _vm._v(" "), _c('span', {
    staticClass: "class-name"
  }, [_vm._v("\n    " + _vm._s(_vm.item.character.className) + "\n  ")]), _vm._v(" "), (_vm.item.primaryStat) ? _c('div', {
    staticClass: "primary-stat",
    class: [_vm.item.damageTypeName.toLowerCase()]
  }, [_c('div', [(_vm.item.damageType.showIcon) ? _c('img', {
    attrs: {
      "src": _vm.item.damageTypeIcon
    }
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.item.primaryStat) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "real",
    attrs: {
      "title": "Power level without mod"
    }
  }, [_vm._v("\n      (" + _vm._s(_vm.item.realPrimaryStat) + ")\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icons-small"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.canEquip),
      expression: "item.canEquip"
    }],
    staticClass: "icon equipped"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.equipped),
      expression: "item.equipped"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unEquip($event)
      }
    }
  }, [_vm._v("bookmark")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.equipped),
      expression: "!item.equipped"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.equip($event)
      }
    }
  }, [_vm._v("bookmark_border")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.key),
      expression: "item.key"
    }],
    staticClass: "icon favorite"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.favorited),
      expression: "item.favorited"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unFavorite($event)
      }
    }
  }, [_vm._v("star")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.favorited),
      expression: "!item.favorited"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.favorite($event)
      }
    }
  }, [_vm._v("star_border")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.canToggleLock),
      expression: "item.canToggleLock"
    }],
    staticClass: "icon lock"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.isLocked),
      expression: "item.isLocked"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unLock($event)
      }
    }
  }, [_vm._v("lock")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.isLocked),
      expression: "!item.isLocked"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lock($event)
      }
    }
  }, [_vm._v("lock_open")])])]), _vm._v(" "), _c('div', {
    staticClass: "sockets"
  }, _vm._l((_vm.item.displayableSockets), function(socket) {
    return _c('div', {
      staticClass: "socket"
    }, [_c('img', {
      attrs: {
        "src": '//www.bungie.net' + socket.displayProperties.icon,
        "title": socket.displayProperties.name
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "icons"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.key),
      expression: "item.key"
    }],
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showTagsSelector($event)
      }
    }
  }, [_vm._v("menu")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23bcfcee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 543
// module chunks = 1